var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}



//////////////////
// WEBPACK FOOTER
// ./~/create-hash/md5.js
// module id = EXeW
// module chunks = 3